import React from 'react';
import HlsPlayer from 'react-hls-player';
import {
  Col,
  Typography,
  Image,
  Row,
} from 'antd';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';

import CustomDrawer from '../../drawer';
import HtmlText from '../../html-text';
import WebCamIcon from './WebCamIcon';
import ConnectionStatus from '../../../pages/data-console/management/ConnectionStatus';

const WebCamDrawer = (props) => {
  const { webcam, visible, setVisible } = props;
  // const [isSummary, toggleIsSummary] = useState(true);
  // removing summary for now, but leaving in case we want to bring it back

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const initialDrawerPlacement = isMobile ? 'bottom' : 'left';

  const hlsUrl = webcam.external_asset?.feeds
    ?.flatMap((feed) => feed.products || [])
    ?.flatMap((product) => product.services || [])
    ?.flatMap((service) => service.data?.properties?.connections || [])
    ?.find((connection) => connection.protocol === 'hls')
    ?.url || null;

  const stillsUrls = webcam?.one_minute_stills?.map((still) => still?.data?.properties?.url);

  return (
    <CustomDrawer
      className="webcam-drawer"
      visible={visible}
      handleShowDrawer={setVisible}
      placement={initialDrawerPlacement}
      width={isMobile ? '100%' : '40%'}
      // height={isMobile ? isSummary ? '50%' : '100%' : '100%'}
      height="100%"
    >
      {/* {isSummary && isMobile && (
        <Row
          justify="center"
          style={{
            marginTop: -20,
          }}
        >
          <UpOutlined
            onClick={() => toggleIsSummary(false)}
            draggable
            style={{
              fontSize: 20,
              position: 'absolute',
              cursor: 'pointer',
              transform: 'translateY(-40px)',
            }}
          />
        </Row>
      )} */}
      <Typography.Title
        style={{
          color: 'white',
          fontSize: 20,
        }}
      >
        {webcam.external_asset.data.common.label}
      </Typography.Title>
      <div
        style={{
          marginBottom: 20,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            color: 'white',
          }}
        >
          <WebCamIcon
            width={24}
            height={24}
          />
          Webcam
        </div>
        <ConnectionStatus latestTimestamp={Math.floor(Date.now() / 1000)} />
      </div>
      {hlsUrl && hlsUrl?.length > 0 && (
        <HlsPlayer
          src={hlsUrl}
          autoPlay
          muted
          controls
          width="100%"
          height="auto"
          playsInline
          webkit-playsinline="true"
        />
      )}
      <Typography.Paragraph
        style={{
          color: 'white',
          marginTop: 10,
          fontSize: 16,
        }}
      >
        {webcam?.description && <HtmlText string={webcam.description} />}
        {webcam?.external_id && webcam?.external_id_type === 'webcoos' && (
          <>
            See more on
            {' '}
            <a
              style={{
                color: 'white',
                textDecoration: 'underline',
              }}
              href={`https://webcoos.org/cameras/${webcam.external_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              webcoos.org
            </a>
          </>
        )}
      </Typography.Paragraph>
      {stillsUrls && stillsUrls.length > 0 && (
        <>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography.Paragraph
              style={{
                whiteSpace: 'nowrap',
                color: 'white',
                fontSize: 16,
                margin: 0,
                padding: '0 10px 0 0',
              }}
            >
              One-minute stills
            </Typography.Paragraph>
            <span
              style={{
                background: 'white',
                height: 1,
                width: '100%',
              }}
            />
          </div>
          <Image.PreviewGroup preview={{ loop: true }}>
            <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
              {stillsUrls.map((url, index) => (
                <Col span={12} key={index}>
                  <Image
                    src={url}
                    alt={`Webcam still ${index + 1}`}
                    // Optional: subtle overlay on hover
                    preview={{ mask: <span style={{ fontWeight: 600 }}>Click to preview</span> }}
                    // Optional: skeleton while loading
                    // placeholder={<Image preview={false} style={{ width: "100%", height: 160, background: "#f0f0f0" }} />}
                  />
                </Col>
              ))}
            </Row>
          </Image.PreviewGroup>
        </>
      )}
    </CustomDrawer>
  );
};

WebCamDrawer.propTypes = {
  webcam: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

export default WebCamDrawer;
